<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M8.65747 6.43481C9.09139 6.0009 9.79489 6.0009 10.2288 6.43481C10.6627 6.86875 10.6627 7.57225 10.2288 8.00616C9.79489 8.44008 9.09139 8.44008 8.65747 8.00616C8.22355 7.57225 8.22355 6.86875 8.65747 6.43481Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.22039 1.22039C-9.93411e-08 2.44077 0 4.40496 0 8.33333C0 12.2617 -9.93411e-08 14.2259 1.22039 15.4462C2.44077 16.6667 4.40496 16.6667 8.33333 16.6667C12.2617 16.6667 14.2259 16.6667 15.4462 15.4462C16.6667 14.2259 16.6667 12.2617 16.6667 8.33333C16.6667 4.40496 16.6667 2.44077 15.4462 1.22039C14.2259 -9.93411e-08 12.2617 0 8.33333 0C4.40496 0 2.44077 -9.93411e-08 1.22039 1.22039ZM12.2095 4.45717C13.7079 5.95562 13.7079 8.38508 12.2095 9.88358C11.2145 10.8785 9.80908 11.2128 8.53825 10.8865C8.33333 10.8338 8.11183 10.8804 7.96217 11.0301L7.03092 11.9613L7.0285 11.9589L6.05677 10.9979C5.81136 10.7552 5.41563 10.7573 5.1729 11.0027C4.93017 11.2482 4.93235 11.6439 5.17777 11.8867L6.147 12.8452L5.89975 13.0925C5.72313 13.2691 5.47581 13.3559 5.22756 13.3283L4.06723 13.1993C3.94352 13.1857 3.82817 13.1302 3.74017 13.0422L3.62449 12.9265C3.53647 12.8385 3.48104 12.7232 3.46729 12.5994L3.33837 11.4391C3.31078 11.1908 3.39754 10.9435 3.57416 10.7669L5.63643 8.70467C5.78607 8.555 5.83281 8.33333 5.78017 8.12842C5.45383 6.85758 5.78815 5.45214 6.78308 4.45717C8.28158 2.95872 10.711 2.95872 12.2095 4.45717Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'StatusRequestIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 17
    }
  }
}
</script>